import React, { useState } from 'react';
import { Field, useFormikContext } from 'formik';

import addNotification from '../../utils/addNotification';
import { NotificationType } from '../../config';
import configService from '../../service/config.service';
import { InputUI, FormErrorUI, FormLabelUI, CheckboxUI, ButtonUI } from '../Interface';

const SmsSettingFields = ({ viewField }) => {
  const { values, errors, validateForm } = useFormikContext();
  const [testing, setTesting] = useState(false);

  const handleConnectionTest = async () => {
    if (testing) return;
    const validationErrors = await validateForm();
    if (
      validationErrors.smsProviderUrl || validationErrors.smsApiKey || validationErrors.smsSender ||
      !values.smsProviderUrl?.trim() || !values.smsApiKey?.trim() || !values.smsSender?.trim()
    ) {
      addNotification({ content: 'A kapcsolat teszteléséhez töltsd ki az SMS kapcsolat adatait.', type: NotificationType.WARNING });
      return;
    }

    setTesting(true);
    try {
      await configService.testSmsConnection({
        smsSendingEnabled: values.smsSendingEnabled ?? false,
        smsProviderUrl: values.smsProviderUrl.trim(),
        smsApiKey: values.smsApiKey.trim(),
        smsSender: values.smsSender.trim(),
      });
      addNotification({ content: 'Sikeres SMS kapcsolat teszt!', type: NotificationType.SUCCESS });
    } catch (error) {
      addNotification({ content: 'Sikertelen SMS kapcsolat teszt!', type: NotificationType.ERROR });
    } finally {
      setTesting(false);
    }
  };

  return (
    <div className="grid grid-cols-6 gap-x-4 mx-4 mb-5">
      <div className="col-span-6 text-sm font-medium text-labelColor mt-2 mb-1">SMS kapcsolat</div>
      {[
        { name: 'smsProviderUrl', label: 'SMS szolgáltató API címe', type: 'url' },
        { name: 'smsApiKey', label: 'API kulcs', type: 'password' },
        { name: 'smsSender', label: 'Feladó neve vagy telefonszáma', type: 'text' },
      ].map(({ name, label, type }) => (
        <div key={name} className="md:col-span-3 xl:col-span-2 col-span-6">
          <Field
            name={name}
            type={type}
            as={InputUI}
            value={values[name] ?? ''}
            fullWidth
            label={<FormLabelUI text={label} />}
            variant="standard"
            helperText={<FormErrorUI message={errors[name]} />}
            disabled={viewField || testing}
            InputLabelProps={{ shrink: Boolean(values[name]) }}
          />
        </div>
      ))}
      <div className="col-span-6 mt-2">
        <ButtonUI
          text={testing ? 'Tesztelés...' : 'Kapcsolat tesztelése'}
          type="button"
          className="bg-primary"
          disabled={viewField || testing}
          onClick={handleConnectionTest}
        />
      </div>
      <div className="col-span-6 text-sm font-medium text-labelColor mt-4 mb-1">Küldési beállítások</div>
      <div className="col-span-6 pt-2">
        <Field
          name="smsSendingEnabled"
          type="checkbox"
          as={CheckboxUI}
          label={<FormLabelUI text="SMS küldés engedélyezése" />}
          disabled={viewField || testing}
        />
      </div>
    </div>
  );
};

export default SmsSettingFields;
